import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledSummary = styled.p<{ $isEmpty?: boolean }>`
  margin: 0;
  ${pickThemeFontStyles('14', '23')}
  ${({ $isEmpty }) => $isEmpty && `color: ${COLORS.TEXT_HINT};`}
`;
